export default {
  fields: {
    fetching: {
      getFields: false,
      getFieldModelById: false,
      getFieldsDeleted: false,
      updateStatusFieldModelById: false,
    },
    api: {
      tableFields: [],
      tableFieldsDeleted: [],
    },
  },
  fieldsFromManager: {
    fetching: {
      getFieldModelById: false,
      getFieldsFromManager: false,
    },
    api: {
      tableFieldsFromManager: [],
    },
  },
};
